import React, { useState } from 'react';
import './App.css';

const COACHES = [
  { username: 'coach1', password: 'pass1', name: 'Coach 1', role: 'coach' },
  { username: 'coach2', password: 'pass2', name: 'Coach 2', role: 'coach' },
  { username: 'coach3', password: 'pass3', name: 'Coach 3', role: 'coach' },
  { username: 'manager', password: 'manager', name: 'Manager', role: 'manager' },
];

const LOCATIONS = {
  'Yoga': ['Studio','Combat 1','Combat 2','DUT Area','Weights 1','Weights 2','Weights 3','PC Area'],
  'Ogikubo': ['Studio','Combat','Octagon','DUT Area 1','DUT Area 2','DUT Area 3','DUT Area 4'],
};

const HOURS = {
  'Yoga':    { weekday:{open:7,close:21}, saturday:{open:7,close:18}, sunday:{open:7,close:17} },
  'Ogikubo': { weekday:{open:8,close:21}, saturday:{open:8,close:17}, sunday:{open:8,close:16} },
};

const DURATIONS = [30,60,90,120,150,180];

function getDayType(d){const w=new Date(d+'T12:00:00').getDay();return w===0?'sunday':w===6?'saturday':'weekday';}
function getSlots(loc,d){const h=HOURS[loc][getDayType(d)];const s=[];for(let m=h.open*60;m<h.close*60;m+=30)s.push(`${Math.floor(m/60).toString().padStart(2,'0')}:${(m%60).toString().padStart(2,'0')}`);return s;}
function s2m(s){const[h,m]=s.split(':').map(Number);return h*60+m;}
function endTime(slot,dur){const m=s2m(slot)+dur;return`${Math.floor(m/60).toString().padStart(2,'0')}:${(m%60).toString().padStart(2,'0')}`;}
function fmtDur(d){if(d<60)return`${d}min`;if(d%60===0)return`${d/60}h`;return`${Math.floor(d/60)}h${d%60}m`;}
function fmtDate(d){return new Date(d+'T12:00:00').toLocaleDateString('en-GB',{weekday:'short',day:'numeric',month:'short'});}
function today(){return new Date().toISOString().split('T')[0];}
function isSlotTaken(sm,list){return list.some(b=>{const s=s2m(b.slot);return sm>=s&&sm<s+b.duration;});}
function maxDur(slot,loc,d,list){const sm=s2m(slot);const cm=HOURS[loc][getDayType(d)].close*60;let mx=cm-sm;list.forEach(b=>{const s=s2m(b.slot);if(s>sm)mx=Math.min(mx,s-sm);});return mx;}
function load(){try{return JSON.parse(localStorage.getItem('pc_bookings')||'[]');}catch{return[];}}
function save(l){localStorage.setItem('pc_bookings',JSON.stringify(l));}

export default function App() {
  const [coach,setCoach]=useState(null);
  const [tab,setTab]=useState('book');
  const [bookings,setBookingsRaw]=useState(load);
  function setBookings(l){setBookingsRaw(l);save(l);}
  if(!coach) return <Login onLogin={c=>{setCoach(c);setTab(c.role==='manager'?'all':'book');}}/>;
  return (
    <div className="app">
      <div className="top-header">
        <div className="header-left">
          <div className="ufc-logo">UFC</div>
          <div><div className="header-title">UFC GYM JAPAN</div><div className="header-sub">Private Coaching Booking</div></div>
        </div>
        <div style={{display:'flex',alignItems:'center',gap:12}}>
          <span className="coach-badge">{coach.name}</span>
          <button className="btn btn-ghost btn-sm" onClick={()=>setCoach(null)}>Sign out</button>
        </div>
      </div>
      <div className="nav-tabs">
        {coach.role==='coach'&&<button className={`nav-tab${tab==='book'?' active':''}`} onClick={()=>setTab('book')}>Book a Space</button>}
        {coach.role==='coach'&&<button className={`nav-tab${tab==='mybookings'?' active':''}`} onClick={()=>setTab('mybookings')}>My Bookings</button>}
        <button className={`nav-tab${tab==='all'?' active':''}`} onClick={()=>setTab('all')}>All Bookings</button>
      </div>
      <div className="content">
        {tab==='book'&&coach.role==='coach'&&<BookTab coach={coach} bookings={bookings} setBookings={setBookings}/>}
        {tab==='mybookings'&&coach.role==='coach'&&<MyBookingsTab coach={coach} bookings={bookings} setBookings={setBookings}/>}
        {tab==='all'&&<AllBookingsTab bookings={bookings} setBookings={setBookings} isManager={coach.role==='manager'}/>}
      </div>
    </div>
  );
}

function Login({onLogin}) {
  const [user,setUser]=useState('');
  const [pass,setPass]=useState('');
  const [err,setErr]=useState(false);
  function attempt(){const c=COACHES.find(c=>c.username===user.trim().toLowerCase()&&c.password===pass);if(c){setErr(false);onLogin(c);}else setErr(true);}
  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-logo-row">
          <div className="ufc-logo">UFC</div>
          <div><div className="login-title">UFC GYM JAPAN</div><div className="login-sub">Private Coaching Booking</div></div>
        </div>
        <div className="form-group"><label>Username</label><input value={user} onChange={e=>setUser(e.target.value)} placeholder="username" autoComplete="username"/></div>
        <div className="form-group"><label>Password</label><input type="password" value={pass} onChange={e=>setPass(e.target.value)} placeholder="••••••" autoComplete="current-password" onKeyDown={e=>e.key==='Enter'&&attempt()}/></div>
        <button className="btn btn-primary" onClick={attempt}>Sign In</button>
        {err&&<p className="error">Incorrect username or password.</p>}
      </div>
    </div>
  );
}

function BookTab({coach,bookings,setBookings}) {
  const [selLoc,setSelLoc]=useState(null);
  const [selSpace,setSelSpace]=useState(null);
  const [selDate,setSelDate]=useState(today());
  const [selSlot,setSelSlot]=useState(null);
  const [selDur,setSelDur]=useState(null);
  const [success,setSuccess]=useState(false);
  const taken=selLoc&&selSpace&&selDate?bookings.filter(b=>b.location===selLoc&&b.space===selSpace&&b.date===selDate):[];
  const slots=selLoc&&selDate?getSlots(selLoc,selDate):[];
  const mx=selSlot?maxDur(selSlot,selLoc,selDate,taken):0;
  function confirm(){
    if(!selLoc||!selSpace||!selDate||!selSlot||!selDur)return;
    setBookings([...bookings,{id:Date.now(),coach:coach.name,location:selLoc,space:selSpace,date:selDate,slot:selSlot,duration:selDur}]);
    setSuccess(true);setSelSlot(null);setSelDur(null);
    setTimeout(()=>setSuccess(false),2500);
  }
  return (
    <div className="card">
      <div className="card-title">New Booking</div>
      <div className="step-row"><span className="step-label">Location</span>
        <div className="pill-group">{Object.keys(LOCATIONS).map(l=><button key={l} className={`pill${selLoc===l?' selected':''}`} onClick={()=>{setSelLoc(l);setSelSpace(null);setSelSlot(null);setSelDur(null);}}>{l}</button>)}</div>
      </div>
      <div className="step-row"><span className="step-label">Space</span>
        <div className="pill-group">{selLoc?LOCATIONS[selLoc].map(s=><button key={s} className={`pill${selSpace===s?' selected':''}`} onClick={()=>{setSelSpace(s);setSelSlot(null);setSelDur(null);}}>{s}</button>):<span className="muted">Select a location first</span>}</div>
      </div>
      <div className="step-row"><span className="step-label">Date</span>
        <input type="date" value={selDate} min={today()} onChange={e=>{setSelDate(e.target.value);setSelSlot(null);setSelDur(null);}} style={{width:'auto',maxWidth:190}}/>
      </div>
      {selLoc&&selSpace&&selDate&&(<>
        <div className="slots-section-title">Start Time</div>
        <div className="slots-grid">
          {slots.map(slot=>{const tk=isSlotTaken(s2m(slot),taken);return(
            <button key={slot} className={`slot${tk?' taken':''}${selSlot===slot?' selected':''}`} disabled={tk} onClick={()=>{if(!tk){setSelSlot(slot);setSelDur(null);}}}>
              {slot}
            </button>
          );})}
        </div>
      </>)}
      {selSlot&&(
        <div className="step-row" style={{marginTop:'1.25rem'}}><span className="step-label">Duration</span>
          <div className="pill-group">{DURATIONS.map(d=><button key={d} className={`pill${selDur===d?' selected':''}${d>mx?' disabled':''}`} disabled={d>mx} onClick={()=>setSelDur(d)}>{fmtDur(d)}</button>)}</div>
        </div>
      )}
      {selSlot&&selDur&&(<>
        <div className="divider"/>
        <div className="booking-summary">
          <div className="booking-summary-loc">{selLoc} — {selSpace}</div>
          <div className="booking-summary-time">{fmtDate(selDate)} · {selSlot} – {endTime(selSlot,selDur)} · {fmtDur(selDur)}</div>
        </div>
        <button className="btn btn-primary" onClick={confirm}>Confirm Booking</button>
      </>)}
      {success&&<p className="success-msg">✓ Booking confirmed!</p>}
    </div>
  );
}

function MyBookingsTab({coach,bookings,setBookings}) {
  const t=today();
  const mine=bookings.filter(b=>b.coach===coach.name&&b.date>=t).sort((a,b)=>a.date.localeCompare(b.date)||a.slot.localeCompare(b.slot));
  if(!mine.length)return<p className="empty">No upcoming bookings</p>;
  return(<div>
    <div className="section-label">My Upcoming Bookings</div>
    {mine.map(b=>(
      <div key={b.id} className="booking-card">
        <div className="booking-row">
          <div>
            <div className="booking-title">{b.space}<span className="badge">{b.location}</span></div>
            <div className="booking-meta">{fmtDate(b.date)} · {b.slot} – {endTime(b.slot,b.duration)} · {fmtDur(b.duration)}</div>
          </div>
          <button className="btn btn-sm btn-danger" onClick={()=>setBookings(bookings.filter(x=>x.id!==b.id))}>Cancel</button>
        </div>
      </div>
    ))}
  </div>);
}

function AllBookingsTab({bookings,setBookings,isManager}) {
  const [filterLoc,setFilterLoc]=useState(null);
  const [filterDate,setFilterDate]=useState('');
  const t=today();
  let list=bookings.filter(b=>b.date>=t);
  if(filterLoc)list=list.filter(b=>b.location===filterLoc);
  if(filterDate)list=list.filter(b=>b.date===filterDate);
  list=list.sort((a,b)=>a.date.localeCompare(b.date)||a.slot.localeCompare(b.slot));
  return(<div>
    <div className="step-row"><span className="step-label">Location</span>
      <div className="pill-group">{['All',...Object.keys(LOCATIONS)].map(l=><button key={l} className={`pill${(filterLoc||'All')===l?' selected':''}`} onClick={()=>setFilterLoc(l==='All'?null:l)}>{l}</button>)}</div>
    </div>
    <div className="step-row"><span className="step-label">Date</span>
      <div style={{display:'flex',alignItems:'center',gap:8}}>
        <input type="date" value={filterDate} min={t} onChange={e=>setFilterDate(e.target.value)} style={{width:'auto',maxWidth:190}}/>
        {filterDate&&<button className="btn btn-sm btn-ghost" onClick={()=>setFilterDate('')}>Clear</button>}
      </div>
    </div>
    {!list.length?<p className="empty">No upcoming bookings</p>:list.map(b=>(
      <div key={b.id} className="booking-card">
        <div className="booking-row">
          <div>
            <div className="booking-title">{b.space}<span className="badge">{b.location}</span></div>
            <div className="booking-meta">{fmtDate(b.date)} · {b.slot} – {endTime(b.slot,b.duration)} · {fmtDur(b.duration)}</div>
            <div className="booking-coach">{b.coach}</div>
          </div>
          {isManager&&<button className="btn btn-sm btn-danger" onClick={()=>setBookings(bookings.filter(x=>x.id!==b.id))}>Cancel</button>}
        </div>
      </div>
    ))}
  </div>);
}
